export default function(value) {
  if (!value) return '';
  if (value.length !== 10) return value;
  return [value.substr(8, 2), value.substr(5, 2), value.substr(0, 4)].join('.');
}
